import React, { useEffect, useRef, useState } from "react";
import { Globals as OldGlobals  } from "../../global/Globals";
import GenericHeader from "../../components/GenericHeader/GenericHeader";
import "./UpdateNewUser.css";
import DropdownList from "../../components/DropdownList/DropdownList";
import { validatePhoneNumber } from "../../util/util";
import PopUp from "../../components/PopUp/PopUp";
import { useNavigate } from "react-router-dom";
import { fetchByfilter, fetchAllRoles } from "../../services/GenericAPI";
import { fetchFilterByCreatedBynewUser } from "../../services/dashboardAPI";
import {
  setAllClusters,
  setAllRoles,
  setAllReporting,
  clearAllReporting,
  clearAllClusters,
  clearAllRoles
} from "../SignUp/ProducerRegistrationSlice";
import { useDispatch, useSelector } from "react-redux";
import { updateNewUserApi } from "../../services/api";
import { useLocation } from "react-router-dom";
import CheckboxDropDown from "../../components/CheckboxDropDown/CheckboxDropDown";
import { useLanguage } from "../../context/Languagecontext";
const UpdateNewUser = () => {
 const { Globals, languages, setLanguages } = useLanguage();
  const location = useLocation();
  const dropdownRefs = useRef({});
  const { activeHeader, formValues } = location.state || "";
  const [inputs, setInputs] = useState({
    name: formValues?.name || "",
    email: formValues?.email || "",
    designationRoleIds:['3','4','5','6'],
    designation: formValues?.designation.join(',') || "",
    reporting: formValues?.reportingTo || "",
    phoneNumber: formValues?.phoneNumber || "",
    location: formValues?.location || "",
    roles: formValues?.roles || [],
    clusterName: formValues?.clusterName || [],
  });
  const [isLocationInvalid, setIsLocationInvalid] = useState(false);
  const [isButtonActivate, setIsButtonActivate] = useState(false);
  const [isNameInvalid, setIsNameInvalid] = useState(false);
  const [validDesignation, setValidDesignation] = useState(true);
  const [validCluster, setValidCluster] = useState(true);
  const [validReportingTo, setValidReportingTo] = useState(true);
  const [isPhoneInValid, setIsPhoneInValid] = useState(false);
  const [isSMStatus, setSMStatus]=useState(false);
  const [isEmptyDesignations, setIsEmptyDesignations] = useState(false);
  const [isEmptyClusters, setIsEmptyClusters] = useState(false);
  const [roleValue, setRoleValue] = useState("");
    const [selectedRole,setSelectedRole]=useState({isSysAdmin:false, isInternalUser:false, isHopUser: false});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeDropdown, setActiveDropdown] = useState(false);
  const [initialPageLoad, setInitialPageLoad] = useState(true);
  const allClusterList = useSelector(
    (state) => state.producerRegistration.allClusters
  );
  const allRolesData = useSelector(
    (state) => state.producerRegistration.allRoles
  );
  const allreportingData = useSelector(
    (state) => state.producerRegistration.allReporting
  );
  const allClustersData = allClusterList?.map((cluster) => cluster.name);
  const allRoleList = allRolesData?.filter((role) => role.roleId !== 6).map((role) => ({
    id: role.roleId,
    name: role.roleName
  }));
  const reportingData = allreportingData?.map((val) => val.name);
  const [newRoleId, setNewRoleId] = useState();
  const [reportingID, setReportingID] = useState("");
  const clusterAllowedRoles = [
    Globals.USER_ROLES.CE,
    Globals.USER_ROLES.CC,
    Globals.USER_ROLES.PRODUCER,
    Globals.USER_ROLES.SNR_MGR,
    Globals.USER_ROLES.HOP,
  ].includes(newRoleId?.toString());
  const reportingToAllowedRoles = [
    Globals.USER_ROLES.CE,
    Globals.USER_ROLES.CC,
    Globals.USER_ROLES.PRODUCER,
  ].includes(newRoleId?.toString());
  const [dropdownState, setDropdownState] = useState({
      activeDropdown: false,
      dropdowns: {
        DESIGNATIONS: { selected: [], selectedText: [] },
        CLUSTERS: { selected: [], selectedText: [] }
      },
  });

  const [popUpState, setPopUpState] = useState({
    open: false,
    title: "",
    text: "",
    negativeAction: null,
    normalAction: null,
    negativeActionText: "",
    normalActionText: "",
  });

  const gotoHome = (data) => {
    dispatch(clearAllRoles());
    dispatch(clearAllClusters());
    dispatch(clearAllReporting());
    navigate(OldGlobals.NAVPATH.HOME, {
      state: {
        activeHeader: activeHeader,
        toastValue: data,
        activeTabData: OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT,
      },
    });
  };

  const UpdateUser = (body) => {
    updateNewUserApi(body, formValues.userId)
      .then((response) => {
        response.data.status === "OK"
          ? gotoHome({
              open: true,
              status: "success",
              title: Globals.UPDATE_USER_SUCCESS_TOAST,
            })
          : openPopUp("failed");
      })
      .catch((error) => {
        console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
        openPopUp("failed");
      });
  };

  const openPopUp = (popUpType) => {
    let requestBody={};
    const matchedItem = allreportingData.find(item => item.name === inputs.reporting.trim());
    const reportingGUId = matchedItem ? matchedItem.id : null;
    const isUserSM=dropdownState.dropdowns.DESIGNATIONS.selected.includes('2');
    if (!isUserSM && !selectedRole.isHopUser) {
      requestBody = {
        name: inputs.name?.trim() || "", // Assuming firstName is part of inputs
        email: inputs.email || "",
        cluster: selectedRole.isSysAdmin ? [] : dropdownState.dropdowns.CLUSTERS && dropdownState.dropdowns.CLUSTERS.selected || (allClusterList?.filter((item) => formValues?.clusterName?.includes(item.name)).map((item) => item.id)) || [], // Assuming cluster has an ID property
        phoneNumber: inputs.phoneNumber || "",
        designation: selectedRole.isSysAdmin ? [1] : selectedRole.isHopUser ? [6] : dropdownState.dropdowns.DESIGNATIONS && dropdownState.dropdowns.DESIGNATIONS.selected || (allRoleList?.filter((item) => formValues?.designation?.includes(item.name)).map((item) => item.id)) || [], // Assuming designation corresponds to roles
        location: inputs.location?.trim() || "",
        reportingTo: reportingGUId
      }
    }
    
    if(isUserSM){
       requestBody={
      name: inputs.name?.trim() || "", // Assuming firstName is part of inputs
      email: inputs.email || "",
      cluster:  selectedRole.isSysAdmin?[]: dropdownState.dropdowns.CLUSTERS&&dropdownState.dropdowns.CLUSTERS.selected || (allClusterList?.filter((item) => formValues?.clusterName?.includes(item.name)).map((item) => item.id)) || [], // Assuming cluster has an ID property
      phoneNumber: inputs.phoneNumber || "",
      designation: selectedRole.isSysAdmin?[1]: dropdownState.dropdowns.DESIGNATIONS&&dropdownState.dropdowns.DESIGNATIONS.selected || (allRoleList?.filter((item) => formValues?.designation?.includes(item.name)).map((item) => item.id)) || [], // Assuming designation corresponds to roles
      location: inputs.location?.trim() || "",       
    }
  }

    if(selectedRole.isHopUser){
       requestBody={
      name: inputs.name?.trim() || "", // Assuming firstName is part of inputs
      email: inputs.email || "",
      cluster:  selectedRole.isSysAdmin?[]: dropdownState.dropdowns.CLUSTERS&&dropdownState.dropdowns.CLUSTERS.selected || (allClusterList?.filter((item) => formValues?.clusterName?.includes(item.name)).map((item) => item.id)) || [], // Assuming cluster has an ID property
      phoneNumber: inputs.phoneNumber || "",
      designation: selectedRole.isSysAdmin?[1]: selectedRole.isHopUser?[6] :dropdownState.dropdowns.DESIGNATIONS&&dropdownState.dropdowns.DESIGNATIONS.selected || [], // Assuming designation corresponds to roles
      location: inputs.location?.trim() || "",       
    }
  }
    switch (popUpType) {
      case "abort":
        setPopUpState({
          open: true,
          title: Globals.UPDATE_USER.ABORT_POPUP_TITLE,
          text: Globals.UPDATE_USER.ABORT_POPUP_MESSAGE,
          negativeAction: gotoHome,
          negativeActionText: Globals.UPDATE_USER.ABORT_BUTTON_TEXT,
        });
        break;
      case "submit":
        setPopUpState({
          open: true,
          title: Globals.UPDATE_USER.TITLE,
          text: Globals.UPDATE_USER.POPUP_MESSAGE,
          normalAction: () => UpdateUser(requestBody),
          normalActionText: Globals.UPDATE_USER.FOOTER_BTN_TITLE,
        });
        break;
      case "failed":
        setPopUpState({
          open: true,
          title: Globals.UPDATE_USER.FAILURE_POPUP_TITLE,
          text: Globals.UPDATE_USER.FAILURE_POPUP_MESSAGE,
          normalAction: () => UpdateUser(requestBody),
          normalActionText: Globals.UPDATE_USER.FAILURE_BUTTON_TEXT,
          popupType: popUpType,
        });
        break;
    }
  };

  const handlePhoneNumber = (event) => {
    setIsPhoneInValid(false);
    const phNumber = event.target.value;
    setInputs((prevInputs) => ({ ...prevInputs, phoneNumber: phNumber }));
    phNumber.length > 0
      ? setIsPhoneInValid(!validatePhoneNumber(phNumber))
      : setIsPhoneInValid(true);
  };

  const checkForEmptyNumber = () => {
    if (inputs.phoneNumber.trim() === "") {
      setIsPhoneInValid(true);
    } else {
      const res = validatePhoneNumber(inputs.phoneNumber);
      setIsPhoneInValid(!res);
    }
  };

  useEffect(() => {
    setInitialPageLoad(true);
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
  }, []);

  useEffect(() => {
    if (formValues && Object.keys(formValues).length) {
      const clusterData = allClusterList?.reduce(
        (acc, cluster) => {
          if (formValues.clusterName.includes(cluster.name)) {
            acc.selected.push(String(cluster.id));
            acc.selectedText.push(String(cluster.name));
          }
          return acc;
        },
        { selected: [], selectedText: [] }
      );
      const designationData = allRoleList?.reduce(
        (acc, role) => {
          if (formValues.designation.includes(role.name)) {
            acc.selected.push(String(role.id));
            acc.selectedText.push(String(role.name));
          }
          return acc;
        },
        { selected: [], selectedText: [] }
      );

      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
           ...prev.dropdowns,        // Retain DESIGNATIONS and other dropdowns
        CLUSTERS: clusterData,    // Only update CLUSTERS
        DESIGNATIONS: designationData, // Retain DESIGNATIONS
        },
      }));
    }
  }, [allClusterList?.length, allRoleList?.length]);

  useEffect(() => {
    setInitialPageLoad(true);
    if (allClustersData || allClustersData.length === 0) {
      fetchByfilter(OldGlobals.FILTER_OPTIONS_NAME.CLUSTERS).then((response) => {
        dispatch(
          setAllClusters({
            allClusters:
              response.data.content[OldGlobals.FILTER_OPTIONS_NAME.CLUSTERS],
          })
        );
      });
    }
    getAllRoles();
    return () => {
      dispatch(setAllReporting([]));
    };
  }, []);

  useEffect(() => {
    if (inputs.designation && allRolesData) {
      const id = allRolesData.find(
        (item) => item.roleName === inputs.designation
      )?.roleId;
      setNewRoleId(id);
    }
    if (inputs.reporting && allreportingData) {
      const id = allreportingData.find(
        (item) => item.name === inputs.reporting
      )?.id;
      setReportingID(id);
    }
  }, [inputs, allRolesData, allreportingData]);

  useEffect(() => {
    dropdownState.dropdowns.CLUSTERS.selected?.length &&
      getFilteredByCreatedBy(dropdownState.dropdowns.CLUSTERS.selected);
  }, [dropdownState.dropdowns.CLUSTERS.selected]);

  const getAllRoles = async () => {
    try {
      const response = await fetchAllRoles();
      const result=response.data.content.filter((item) => item.roleId!==1 && item.roleName!==Globals.USER_ROLES_NAMES.SYS_ADMIN);
      dispatch(setAllRoles(result));
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };
  const getFilteredByCreatedBy = async (clusterId) => {
    dispatch(setAllReporting([]));
    fetchFilterByCreatedBynewUser(
      [Number(Globals.USER_ROLES.SNR_MGR), Number(Globals.USER_ROLES.HOP)],
      clusterId
    ) //roleid and clusterid should pass as array
      .then((response) => {
        const filterReportingToList= response?.data?.content?.filter(item => item?.id !==formValues?.userId)
        dispatch(setAllReporting(filterReportingToList));
      })
      .catch((error) => {
        console.error("Failed to fetch data:", error);
      });
  };

  //This code to validate all mandatory fields and enabled button accordingly
  useEffect(() => {
    if (selectedRole?.isSysAdmin === true) {
      if (inputs.name.length > 0 &&
        inputs.email.length > 0 &&
        inputs.phoneNumber.length > 0 &&
        inputs.location.length > 0 &&
        !isNameInvalid &&
        !isPhoneInValid &&
        !isLocationInvalid
      ) {
        setIsButtonActivate(true);
      }
      else {
        setIsButtonActivate(false);
      }
    }
    if (selectedRole?.isInternalUser === true) {
      const isSeniorManager = (dropdownState.dropdowns.DESIGNATIONS.selected.some(d => d.includes('2')));
      const isReportingValid = isSeniorManager
        ? inputs.reporting.length === 0
        : inputs.reporting.length > 0;
      if (
        inputs.name.length > 0 &&
        inputs.email.length > 0 &&
        inputs.phoneNumber.length > 0 &&
        inputs.location.length > 0 &&
        (dropdownState.dropdowns.DESIGNATIONS.selected.length > 0 || formValues.designation.length > 0) &&
        dropdownState.dropdowns.CLUSTERS.selected.length > 0 &&
        ((isSMStatus&&inputs.reporting.length===0)||
        (!isSMStatus&&inputs.reporting.length>0))&&
       // ((isSeniorManager && inputs.reporting.length===0)||(!isSeniorManager && inputs.reporting.length>0))&&
        //isReportingValid &&
        !isNameInvalid &&
        !isPhoneInValid &&
        !isLocationInvalid &&
        validDesignation &&
        validCluster
      ) {
        setIsButtonActivate(true);
      } else {
        setIsButtonActivate(false);
      }
    }

    if (selectedRole?.isHopUser === true) {
      const isHop = (dropdownState.dropdowns.DESIGNATIONS.selected.some(d => d.includes('6')));
      const isReportingValid = isHop
        ? inputs.reporting.length === 0
        : inputs.reporting.length > 0;
      if (
        inputs.name.length > 0 &&
        inputs.email.length > 0 &&
        inputs.phoneNumber.length > 0 &&
        inputs.location.length > 0 &&
        dropdownState.dropdowns.CLUSTERS.selected.length > 0 &&
        !isNameInvalid &&
        !isPhoneInValid &&
        !isLocationInvalid &&
        validDesignation &&
        validCluster
      ) {
        setIsButtonActivate(true);
      } else {
        setIsButtonActivate(false);
      }
    }
  });
  
  useEffect(()=>{
    if(selectedRole.isInternalUser===true){
      dropdownState.dropdowns.DESIGNATIONS.selected.length>0?setValidDesignation(true):setValidDesignation(false);
      dropdownState.dropdowns.CLUSTERS.selected.length>0?setValidCluster(true):setValidCluster(false);
      inputs.reporting.length>0?setValidReportingTo(true):setValidReportingTo(false)
    }
    if(selectedRole.isHopUser === true){
      dropdownState.dropdowns.CLUSTERS.selected.length>0?setValidCluster(true):setValidCluster(false);
    }
  },[dropdownState.dropdowns.DESIGNATIONS.selected, dropdownState.dropdowns.CLUSTERS.selected, inputs.reporting])

  const handleUserName = (event) => {
    const name = event.target.value;
    setIsNameInvalid(name.length === 0);
    setInputs((prevInputs) => ({
      ...prevInputs,
      name,
    }));
  };

  const handleLocation = (event) => {
    const location = event.target.value;
    setIsLocationInvalid(location.length === 0);
    setInputs((prevInputs) => ({
      ...prevInputs,
      location,
    }));
  };

   const handletog = (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const handleSelectAll = (dropdownName, selectAll, options) => {
    const selectedDataSting = options.map((option) => String(option.id));
    const selectedDataText = options.map((option) => String(option.name));
     setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        ...prev.dropdowns,
        [dropdownName]: {
          ...prev.dropdowns[dropdownName],
        selected: selectAll ? selectedDataSting : [],
        selectedText: selectAll ? selectedDataText : [],
      },
    }
    }));
    setInputs((prevInputs) => ({ ...prevInputs, reporting: "" }));
    setReportingID("");
  };

  const handleSelect = (dropdownName, value) => {
    setInitialPageLoad(false);
    setDropdownState((prev) => {
      const dropdown = prev.dropdowns[dropdownName] || { selected: [], selectedText: [] };
      const isSelected = dropdown.selected.includes(String(value.id));
      const isSelectedText = dropdown.selectedText.includes(String(value.name));
      const newSelected = isSelected
        ? dropdown.selected.filter((item) => item !== String(value.id))
        : [...dropdown.selected, String(value.id)];
      const newSelectedText = isSelectedText
        ? dropdown.selectedText.filter((item) => item !== String(value.name))
        : [...dropdown.selectedText, String(value.name)];
      return {
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            selected: newSelected,
            selectedText: newSelectedText,
          },
        },
      };
    });
  };

  const handleClickOutside = (event) => {
    // Check if the click is outside all dropdowns
    const isClickInsideDropdown = Object.values(dropdownRefs.current).some(
      (ref) => ref?.contains(event.target)
    );
    if (!isClickInsideDropdown) {
      handletog(dropdownState.activeDropdown);
    }
  };

  const handleReportingBlur = () => {
    if (!inputs.reporting) {
      setValidReportingTo(false);
    }
  };

  const handleReportingChange = (value) => {
    const id = allreportingData.find((item) => item.name === value)?.id;
    setReportingID(id);
    setInputs((prevInputs) => ({ ...prevInputs, reporting: value }));
    setValidReportingTo(!!value);
  };

  const handleRole=(type, value)=>{ 
    setRoleValue(value);
    setSelectedRole({
      isSysAdmin: value === 'sys_admin',
      isInternalUser: value === 'internalUser',
      isHopUser: value === 'hopUser'
    });
    setInitialPageLoad(false);
  }

  useEffect(() => {
    if((formValues?.designation.includes(Globals.USER_ROLES_NAMES.CC))||(formValues?.designation.includes(Globals.USER_ROLES_NAMES.CE))
      ||(formValues?.designation.includes(Globals.USER_ROLES_NAMES.SM))){
      setSelectedRole({isInternalUser:true, isSysAdmin:false, isHopUser: false});
    }
    if(formValues?.designation.includes(Globals.USER_ROLES_NAMES.SYS_ADMIN)){
      setSelectedRole({isInternalUser:false, isSysAdmin:true, isHopUser: false});
    }
    if(formValues?.designation.includes(Globals.USER_ROLES_NAMES.HOP)){
      setSelectedRole({isInternalUser:false, isSysAdmin:false, isHopUser:true});
    }
  }, []);

  useEffect(()=>{
      if(roleValue === 'sys_admin'){
        if (dropdownState.dropdowns.CLUSTERS) {
          dropdownState.dropdowns.CLUSTERS.selected.length = 0;
          dropdownState.dropdowns.CLUSTERS.selectedText.length = 0;
        }
        if (dropdownState.dropdowns.DESIGNATIONS) {
          dropdownState.dropdowns.DESIGNATIONS.selected.length = 0;
          dropdownState.dropdowns.DESIGNATIONS.selected = ['1'];
          dropdownState.dropdowns.DESIGNATIONS.selectedText.length = 0;
        }
        inputs.reporting = "";
        inputs.designation="";
        setValidCluster(true);
        setValidDesignation(true);
        setValidReportingTo(true);
      }
      else if(roleValue === 'internalUser'){
        dropdownState.dropdowns.DESIGNATIONS.selected.length=0;
        dropdownState.dropdowns.DESIGNATIONS.selectedText.length = 0;
        const filteredValues=dropdownState?.dropdowns?.CLUSTERS?.selected.filter((item) => item !== '1');
        if (dropdownState.dropdowns.CLUSTERS) {
          dropdownState.dropdowns.CLUSTERS.selected = filteredValues;
        }
        dropdownState.dropdowns.DESIGNATIONS.selected.length === 0 ?
          setValidDesignation(false) : setValidDesignation(true);

        dropdownState.dropdowns.CLUSTERS.selected.length === 0 ?
          setValidCluster(false) : setValidCluster(true);
      }
      else if(roleValue === 'hopUser'){
        const filteredValues=dropdownState?.dropdowns?.CLUSTERS?.selected.filter((item) => item !== '1');
        if (dropdownState.dropdowns.CLUSTERS) {
          dropdownState.dropdowns.CLUSTERS.selected = filteredValues;
        }
        dropdownState.dropdowns.CLUSTERS.selected.length === 0 ?
          setValidCluster(false) : setValidCluster(true);
      }
    },[roleValue])

  useEffect(() => {
  const roleList = dropdownState.dropdowns.DESIGNATIONS?.selected?.length
    ? dropdownState.dropdowns.DESIGNATIONS.selected
    : allRoleList?.filter((item) =>
        Array.isArray(formValues?.designation) && formValues.designation.includes(item.name)
      ).map((item) => item.id) || [];

  if (roleList.includes(2) || roleList.includes('2')) {
    setSMStatus(true);
    setInputs(prev => ({ ...prev, reporting: '' }));
  } else {
    setSMStatus(false);
  }
  
  setIsEmptyDesignations(roleList.length === 0);

  const clusterList = dropdownState.dropdowns.CLUSTERS?.selected || [];
  setIsEmptyClusters(clusterList.length === 0);
}, [dropdownState, inputs.designation, allRoleList, formValues?.designation]);

useEffect(() => {
  if(allreportingData.length > 0){
    const name = allreportingData.find(
          (item) => item.name === inputs.reporting.trim()
        )?.name;
    setInputs((prevInputs) => ({ ...prevInputs, reporting: name ?? '' }));
  }
},[allreportingData])

  return (
    <div className="update-user-container">
      <GenericHeader
        title={Globals.UPDATE_NEW_USER}
        onClose={() => openPopUp("abort")}
      />
      <div className="update-user-content">
        <div className="update-user-form">
          <div className="update-user-title">
            {Globals.UPDATE_NEW_USER_BASIC_INFORMATION}
          </div>
          <div className="add-new-user-wrapper">
            <div id="update-user-details-row-1" className="row3-update-user">
              <div className="update-user-score-holder">
                <label
                  id="update-user-region-label"
                  className="update-user-label"
                >
                  {Globals.ADD_NEW_USER_NAME_TITLE}
                  <span id="mandatory" className="mandatory">
                    {Globals.MANDATORY_FIELD}
                  </span>
                </label>
                <input
                  type="text"
                  id="name-inp"
                  value={inputs.name}
                  className={`updateuser-input`}
                  placeholder={Globals.SIGNUP.NAME_INP_PLACEHOLDER}
                  onChange={handleUserName}
                  tabIndex={2}
                  onBlur={handleUserName}
                  maxLength={30}
                  required
                ></input>
                {isNameInvalid && (
                  <div>
                    <img
                      id="login-error"
                      className="login-error"
                      src={Globals.IMG.ERROR}
                      alt="password error"
                    />
                    <label className="invalidadduserCredential">
                      {inputs.name.trim().length === 0
                        ? Globals.ERROR_MESSAGES.EMPTY_NAME
                        : Globals.ERROR_MESSAGES.INVALID_NAME}
                    </label>
                  </div>
                )}
              </div>
              <div className="update-user-score-holder">
                <label
                  id="update-user-region-label"
                  className="update-user-label"
                >
                  {Globals.ADD_NEW_USER_EMAIL_TITLE}
                  <span id="mandatory" className="mandatory">
                    {Globals.MANDATORY_FIELD}
                  </span>
                </label>
                <input
                  type="text"
                  id="proposal-title-input"
                  className={`updateuser-input  ${
                    inputs.email && inputs.email.length > 0 ? "active" : ""
                  }`}
                  placeholder={Globals.ADD_NEW_USER_EMAIL_PLACEHOLDER}
                  value={inputs.email}
                  required
                  disabled
                  tabIndex="2"
                ></input>
              </div>
            </div>
            <div id="update-user-details-row-2" className="row3-update-user">
              <div className="update-user-score-holder">
                <label
                  id="update-user-genre-label"
                  className="update-user-label"
                >
                  {Globals.ADD_NEW_USER_PHONE_NUMBER}
                  <span id="mandatory" className="mandatory">
                    {Globals.MANDATORY_FIELD}
                  </span>
                </label>
                <input
                  type="tel"
                  value={inputs.phoneNumber}
                  pattern="[0-9+]+"
                  id="proposal-title-input"
                  className={`updateuser-input`}
                  placeholder={Globals.SIGNUP.PHONE_NUMBER_INP_PLACEHOLDER}
                  onChange={handlePhoneNumber}
                  onBlur={checkForEmptyNumber}
                  tabIndex={6}
                  required
                  maxLength={inputs.phoneNumber.charAt(0) == "+" ? 16 : 15}
                ></input>
                {isPhoneInValid && (
                  <div>
                    <img
                      id="updateuser-error"
                      className="updateuser-error"
                      src={Globals.IMG.ERROR}
                      alt="phone number error"
                    />
                    <label className="invalidadduserCredential">
                      {inputs.phoneNumber.length > 0
                        ? Globals.ERROR_MESSAGES.INVALID_PHONE_NUMBER
                        : Globals.ERROR_MESSAGES.EMPTY_PHONE_NUMBER}
                    </label>
                  </div>
                )}
              </div>
              <div className="update-user-score-holder">
                <label
                  id="update-user-genre-label"
                  className="update-user-label"
                >
                  {Globals.ADD_NEW_USER_LOCATION}
                  <span id="mandatory" className="mandatory">
                    {Globals.MANDATORY_FIELD}
                  </span>
                </label>
                <input
                  type="text"
                  id="proposal-title-input"
                  className={`updateuser-input  ${
                    inputs.location && inputs.location.length > 0
                      ? "hightlight"
                      : ""
                  }`}
                  placeholder={Globals.ADD_NEW_USER_LOCATION_PLACEHOLDER}
                  onChange={handleLocation}
                  onBlur={handleLocation}
                  value={inputs.location}
                  required
                  tabIndex="7"
                ></input>
                {isLocationInvalid && (
                  <div>
                    <img
                      id="login-error"
                      className="login-error"
                      src={Globals.IMG.ERROR}
                      alt="password error"
                    />
                    <label className="invalidadduserCredential">
                      {Globals.ERROR_MESSAGES.EMPTY_LOCATION}
                    </label>
                  </div>
                )}
              </div>
            </div>

            <div id="add-user-details-row-3" className="row3-add-user">
              <div className="add-user-score-holder">
                <label id="add-user-sctipted-label" className="add-user-label">{Globals.ROLE}
                  <span id="mandatory" className="mandatory">
                    {Globals.MANDATORY_FIELD}
                  </span>
                </label>
                <div className="sa-update-users-radio-btn-group">
                  <label className="role-selection-radio-label">
                    <input type="radio"
                      className="role-selction-radio-buttons"
                      name={Globals.INTERNAL_USERS_ROLE_LIST}
                      checked={selectedRole.isInternalUser}
                      value="1"
                      onClick={() => handleRole(1, 'internalUser')}
                    />
                    {Globals.INTERNAL_USERS_ROLE_LIST}
                  </label>
                  <label className="role-selection-radio-label">
                    <input type="radio"
                        className="role-selction-radio-buttons"
                        name={Globals.HOP_CHANNEL_HEAD_ROLE_LIST}
                        checked={selectedRole.isHopUser}
                        value="2"
                        onClick={() => handleRole(2, 'hopUser')}
                      />
                      {Globals.HOP_CHANNEL_HEAD_ROLE_LIST}
                  </label>
                  <label className="role-selection-radio-label">
                    <input type="radio"
                      className="role-selction-radio-buttons"
                      name={Globals.SYS_ADMIN_ROLE}
                      checked={selectedRole.isSysAdmin}
                      value="3"
                      onClick={() => handleRole(3, 'sys_admin')}
                    />
                    {Globals.SYS_ADMIN_ROLE}
                  </label>
                </div>
              </div>
            </div>

            {selectedRole.isInternalUser&&<div id="update-user-details-row-3" className="row3-update-user">
              <div className="update-user-score-holder">
                <label
                  id="update-user-sctipted-label"
                  className="update-user-label"
                >
                  {Globals.ADD_NEW_USER_DESIGNATION_TITLE}
                  <span id="mandatory" className="mandatory">
                    {Globals.MANDATORY_FIELD}
                  </span>
                </label>
                <CheckboxDropDown
                  isOpen={activeDropdown === "DESIGNATIONS"}
                  options={allRoleList}
                  onToggle={() => handletog('DESIGNATIONS')}
                  onSelectAll={(selectAll, options) =>
                    handleSelectAll("DESIGNATIONS", selectAll, options)
                  }
                  onSelect={(value) => handleSelect("DESIGNATIONS", value)}
                  selectedValues={(dropdownState?.dropdowns?.DESIGNATIONS && dropdownState.dropdowns.DESIGNATIONS.selected)
                    ? dropdownState.dropdowns.DESIGNATIONS.selected
                    : (allRoleList?.filter((item) => formValues?.designation?.includes(item.name)).map((item) => item.id) || [])}
                  selectedItems={(dropdownState?.dropdowns?.DESIGNATIONS && dropdownState.dropdowns.DESIGNATIONS.selectedText)
                    ? dropdownState.dropdowns.DESIGNATIONS.selectedText
                    : (formValues?.designation || [])}
                  title={Globals.ADD_NEW_USER_DESIGNATION_PLACEHOLDER}
                  className={"add-user-dropdown"}
                  outerDivClassName={`${dropdownState.dropdowns?.DESIGNATIONS?.selected?.length > 0  ? "active" : " "
                    } addUserDropdownSize`}
                  dropdownRef={(el) =>
                  (dropdownRefs.current[
                    Globals.ADD_NEW_USER_DESIGNATION_TITLE
                  ] = el)
                  }
                  fontColor={"selected-country"}
                  oneWordText={true}
                />
                {(
                  (!initialPageLoad && dropdownState.dropdowns.DESIGNATIONS.selected.length === 0)
                ) && (
                  <div>
                    <img
                      id="login-error"
                      className="login-error"
                      src={Globals.IMG.ERROR}
                      alt="designation error"
                    />
                    <label className="invalidadduserCredential">
                      {Globals.ERROR_MESSAGES.DESIGNATION}
                    </label>
                  </div>
                )}
              </div>
              { (
                <div className="update-user-score-holder">
                  <label
                    id="update-user-region-label"
                    className="update-user-label"
                  >
                    {Globals.ADD_NEW_USER_CLUSTER_TITLE}
                    <span id="mandatory" className="mandatory">
                      {Globals.MANDATORY_FIELD}
                    </span>
                  </label>
                  <CheckboxDropDown
                    isOpen={activeDropdown === "CLUSTERS"}
                    options={allClusterList}
                    onToggle={() => handletog('CLUSTERS')}
                    selectedValues={(dropdownState?.dropdowns?.CLUSTERS && dropdownState.dropdowns.CLUSTERS.selected)
                      ? dropdownState.dropdowns.CLUSTERS.selected
                      : (allClusterList?.filter((item) => formValues?.clusterName?.includes(item.name)).map((item) => item.id) || [])}
                    selectedItems={(dropdownState?.dropdowns?.CLUSTERS && dropdownState.dropdowns.CLUSTERS.selectedText)
                      ? dropdownState.dropdowns.CLUSTERS.selectedText
                      : (formValues?.clusterName || [])}
                    onSelect={(value) => handleSelect("CLUSTERS", value)}
                    onSelectAll={(selectAll, options) =>
                      handleSelectAll("CLUSTERS",selectAll, options)
                    }
                    title={Globals.ADD_NEW_USER_CLUSTER_REGION_PLACEHOLDER}
                    className={"add-user-dropdown"}
                    outerDivClassName={`${
                      (dropdownState.dropdowns.CLUSTERS &&
                        dropdownState.dropdowns.CLUSTERS.selected &&
                        dropdownState.dropdowns.CLUSTERS.selected.length > 0
                      )
                        ? "active"
                        : ""
                    } addUserDropdownSize`}
                    dropdownRef={(el) =>
                      (dropdownRefs.current[
                        Globals.ADD_NEW_USER_CLUSTER_TITLE
                      ] = el)
                    }
                    fontColor={"selected-country"}
                    oneWordText={true}
                  />
                  {(!initialPageLoad && dropdownState?.dropdowns?.CLUSTERS?.selected && dropdownState.dropdowns.CLUSTERS.selected.length === 0) && (
                    <div>
                      <img
                        id="login-error"
                        className="login-error"
                        src={Globals.IMG.ERROR}
                        alt="cluster error"
                      />
                      <label className="invalidadduserCredential">
                        {Globals.ERROR_MESSAGES.ERROR_CLUSTER}
                      </label>
                    </div>
                  )}
                </div>
              )}
              {((!isSMStatus && (!isEmptyDesignations && !isEmptyClusters))&&
                <div className="update-user-score-holder">
                  <label
                    id="update-user-sctipted-label"
                    className="update-user-label"
                  >
                    {Globals.ADD_NEW_USER_REPORTING_TO}
                    <span id="mandatory" className="mandatory">
                      {Globals.MANDATORY_FIELD}
                    </span>
                  </label>
                  <DropdownList
                    selectClass={"updatenewuserDropdownSize"}
                    placeHolderValue={
                      Globals.ADD_NEW_USER_REPORTING_TO_PLACEHOLDER
                    }
                    options={reportingData}
                    onSelect={handleReportingChange}
                    selectedItem={inputs.reporting}
                    onBlur={handleReportingBlur}
                    required
                    tabIndex="5"
                  />
                  {!initialPageLoad && !validReportingTo && (
                    <div>
                      <img
                        id="login-error"
                        className="login-error"
                        src={Globals.IMG.ERROR}
                        alt="reporting to error"
                      />
                      <label className="invalidadduserCredential">
                        {Globals.ERROR_MESSAGES.ERROR_REPORTINGTO}
                      </label>
                    </div>
                  )}
                </div>
              )}
            </div>}

            {selectedRole.isHopUser&&<div id="update-user-details-row-3" className="row3-update-user">
              { (
                <div className="update-user-score-holder">
                  <label
                    id="update-user-region-label"
                    className="update-user-label"
                  >
                    {Globals.ADD_NEW_USER_CLUSTER_TITLE}
                    <span id="mandatory" className="mandatory">
                      {Globals.MANDATORY_FIELD}
                    </span>
                  </label>
                  <CheckboxDropDown
                    isOpen={activeDropdown === "CLUSTERS"}
                    options={allClusterList}
                    onToggle={() => handletog('CLUSTERS')}
                    selectedValues={(dropdownState?.dropdowns?.CLUSTERS && dropdownState.dropdowns.CLUSTERS.selected)
                      ? dropdownState.dropdowns.CLUSTERS.selected
                      : (allClusterList?.filter((item) => formValues?.clusterName?.includes(item.name)).map((item) => item.id) || [])}
                    selectedItems={(dropdownState?.dropdowns?.CLUSTERS && dropdownState.dropdowns.CLUSTERS.selectedText)
                      ? dropdownState.dropdowns.CLUSTERS.selectedText
                      : (formValues?.clusterName || [])}
                    onSelect={(value) => handleSelect("CLUSTERS", value)}
                    onSelectAll={(selectAll, options) =>
                      handleSelectAll("CLUSTERS",selectAll, options)
                    }
                    title={Globals.ADD_NEW_USER_CLUSTER_REGION_PLACEHOLDER}
                    className={"add-user-dropdown"}
                    outerDivClassName={`${
                      (dropdownState.dropdowns.CLUSTERS &&
                        dropdownState.dropdowns.CLUSTERS.selected &&
                        dropdownState.dropdowns.CLUSTERS.selected.length > 0
                      )
                        ? "active"
                        : ""
                    } addUserDropdownSize`}
                    dropdownRef={(el) =>
                      (dropdownRefs.current[
                        Globals.ADD_NEW_USER_CLUSTER_TITLE
                      ] = el)
                    }
                    fontColor={"selected-country"}
                    oneWordText={true}
                  />
                  {(!initialPageLoad && dropdownState?.dropdowns?.CLUSTERS?.selected && dropdownState.dropdowns.CLUSTERS.selected.length === 0) && (
                    <div>
                      <img
                        id="login-error"
                        className="login-error"
                        src={Globals.IMG.ERROR}
                        alt="cluster error"
                      />
                      <label className="invalidadduserCredential">
                        {Globals.ERROR_MESSAGES.ERROR_CLUSTER}
                      </label>
                    </div>
                  )}
                </div>
              )}
            </div>}
          </div>
        </div>
      </div>

      <div className="update-user-footer">
        <div className="update-user-footer-heading">
          <div className="update-user-footer-btn-group">
            <span
              className="cancel-update-user-btn"
              onClick={() => openPopUp("abort")}
            >
              {Globals.HALF_PAGE_BRIEF_DETAILS.CANCEL}
            </span>
            <button
              onClick={() => {
                openPopUp("submit");
              }}
              id="updateuser-submit-btn"
              disabled={!isButtonActivate}
              className={`updateuser-btn`}
            >
              {Globals.UPDATE_USER.FOOTER_BTN_TITLE}
            </button>
          </div>
        </div>
      </div>
      {popUpState?.open && (
        <PopUp
          onClose={() => setPopUpState({ open: false })}
          text={popUpState.text || ""}
          title={popUpState.title || ""}
          negativeAction={popUpState.negativeAction}
          normalAction={popUpState.normalAction}
          negativeActionText={popUpState.negativeActionText}
          normalActionText={popUpState.normalActionText}
          popupType={popUpState.popupType}
        />
      )}
    </div>
  );
};

export default UpdateNewUser;
